<template>
  <div>
    <q-dialog
      :visible.sync="dialogVisible"
      title="实际销量"
      :innerHeight="360"
      :showFooter="false"
      @cancel="updateVal"
      @close="updateVal"
    >
      <el-table :data="tableData">
        <el-table-column label="店铺/个数" prop="storeName"></el-table-column>
        <el-table-column label="预估销量" prop="forecastSales"></el-table-column>
        <el-table-column label="预估调整" prop="subMonthAdjust"></el-table-column>
        <el-table-column label="当前应售" prop="currentSales"></el-table-column>
        <el-table-column label="实际销量" prop="actualSales"></el-table-column>
        <el-table-column label="预估差额" prop="diffAmount"></el-table-column>
      </el-table>
    </q-dialog>
  </div>
</template>

<script>
import mixin from '@/views/preSalePlan/utils/mixin.js'
export default {
  mixins: [mixin],
  model: {
    prop: 'visible',
    event: 'input'
  },
  props: ['visible', 'data'],
  data() {
    return {
      dialogVisible: false,
      // 业务代码
      tableData: []
    }
  },
  mounted() {
    this.dialogVisible = this.visible;
    this.init();
  },
  methods: {
    init() {
      let data = {
        data: {
          code: this.data.goodsCode,
          planTime: this.planTime,
          type: 1 //商品：1 产品：2
        }
      }
      this.$q.preSalePlan.getStoreSaleNumList(data)
      .then(res=>{
        if(res.code == 200) {
          this.tableData = res.data;
        }
      })
    },
    updateVal() {
      this.dialogVisible = false;
      setTimeout(_=>{
        this.$emit('input', false)
      },200)
    },
    confirm() {
      this.updateVal();
    }
  }
}
</script>

<style>

</style>